// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1rGLn","consentsList":"PatientConsents_consentsList__3zUU3","consentsListEmpty":"PatientConsents_consentsListEmpty__2bx_F"};